import Vue from '/vodalys/vvuejs/vue.js'

Vue.prototype.$sortBy = function sort(data, key, invert = false) {
    const compareFn = (a, b) => {
        const diff = ((a[key] ?? 0) - (b[key] ?? 0));
        return invert ? -diff : diff;
    };

    if (Array.isArray(data)) {
        return data.sort(compareFn);
    } else if (data instanceof Object) {
        return Object.values(data).sort(compareFn);
    }
    return data;
};
